import { Accordion, AccordionDetails, AccordionSummary, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '@/components/text';
import Icon from '@/components/icon';
import Loader from '@/components/loader';

const useStyles = createUseStyles((theme: Theme) => ({
  userSettingsCard: {
    '& .MuiAccordionSummary-root': {
      minHeight: 34,
      padding: '0px 8px',
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      minWidth: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
    '& .MuiAccordionDetails-root': {
      padding: '0px 8px 8px 8px',
    },
    '& .toolbar': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: 4,
      width: '100%',
      margin: '4px 0px 12px',
      '& .MuiFormControl-root': {
        marginTop: 0,
      },
    },
  },
}));

interface Props {
  title: string;
  children: ReactNode;
  loading?: boolean;
}

const UserSettingsCard: FC<Props> = ({ title, children, loading = false }) => {
  const styles = useStyles();

  return (
    <Accordion className={styles.userSettingsCard} elevation={0}>
      <AccordionSummary expandIcon={<Icon name="expand-more" size="x-small" />}>
        <Text bold size="small" dotdot>
          {title}
        </Text>
      </AccordionSummary>
      <AccordionDetails>{loading ? <Loader /> : children}</AccordionDetails>
    </Accordion>
  );
};

export default UserSettingsCard;
